import React from 'react';
import { Modal, Box, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  px: 4,
  py: 2,
  maxHeight: '90vh',    
  overflowY: 'auto',  
};

const ModalWrapMain = ({ open, onClose, title, children, width }) => {
    const defaultWidth = { xs: '90%', sm: 400, md: 500, lg: 600 };
  return (
    <Modal keepMounted open={open} onClose={onClose}>
      <Box sx={{ ...style, width: width || defaultWidth }}>
        {title && (
          <Typography variant="h6" component="h2" sx={{display: "flex",justifyContent: "space-between",alignItems: "center"}}>
               {title}
               <ClearIcon sx={{cursor: "pointer"}} onClick={onClose}/>
          </Typography>
        )}
        <Box>{children}</Box>
      </Box>
    </Modal>
  );
};

export default ModalWrapMain;
